import { useLocation, useNavigate } from 'react-router'
import { useEffect } from 'react'
import { parseStringBoolean } from '../../utils.ts'

export const RedirectOnSignedOut = () => {
	const location = useLocation()
	const navigate = useNavigate()

	useEffect(() => {
		const currentPath = location.pathname + location.search + location.hash
		const isOrganicSignOut = parseStringBoolean(localStorage.getItem('organicSignOut'))
		if (location.pathname !== '/' && !isOrganicSignOut) {
			navigate(`/?redirect=${encodeURIComponent(currentPath)}`)
		}
	}, [])

	return null
}
